import { redirectToNewWindow } from "util/redirect";
import { ReactComponent as LinkIcon } from "../../assets/link.svg";

type NeedHelpProps = {
  redirectUrl: string;
};

export const NeedHelp = ({ redirectUrl }: NeedHelpProps) => {
  return (
    <button
      className="need-help-button button-link-color"
      onClick={() => redirectToNewWindow(redirectUrl)}
    >
      <p className="need-help-text">Need help?</p>
      <LinkIcon focusable="false" />
    </button>
  );
};
